/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Tab_Search_CriteriaInputs */

const en_jobs_tab_search_criteria = /** @type {(inputs: Jobs_Tab_Search_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Criteria`)
};

const de_jobs_tab_search_criteria = /** @type {(inputs: Jobs_Tab_Search_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchkriterien`)
};

const fr_jobs_tab_search_criteria = /** @type {(inputs: Jobs_Tab_Search_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Critères de recherche`)
};

const es_jobs_tab_search_criteria = /** @type {(inputs: Jobs_Tab_Search_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criterios de búsqueda`)
};

const it_jobs_tab_search_criteria = /** @type {(inputs: Jobs_Tab_Search_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criteri di ricerca`)
};

const nl_jobs_tab_search_criteria = /** @type {(inputs: Jobs_Tab_Search_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoekcriteria`)
};

const pl_jobs_tab_search_criteria = /** @type {(inputs: Jobs_Tab_Search_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kryteria wyszukiwania`)
};

const fi_jobs_tab_search_criteria = /** @type {(inputs: Jobs_Tab_Search_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakukriteerit`)
};

const da_jobs_tab_search_criteria = /** @type {(inputs: Jobs_Tab_Search_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søgekriterier`)
};

const sv_jobs_tab_search_criteria = /** @type {(inputs: Jobs_Tab_Search_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sökkriterier`)
};

/**
* | output |
* | --- |
* | "Search Criteria" |
*
* @param {Jobs_Tab_Search_CriteriaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_tab_search_criteria = /** @type {((inputs?: Jobs_Tab_Search_CriteriaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Tab_Search_CriteriaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_tab_search_criteria(inputs)
	if (locale === "fr") return fr_jobs_tab_search_criteria(inputs)
	if (locale === "es") return es_jobs_tab_search_criteria(inputs)
	if (locale === "it") return it_jobs_tab_search_criteria(inputs)
	if (locale === "nl") return nl_jobs_tab_search_criteria(inputs)
	if (locale === "pl") return pl_jobs_tab_search_criteria(inputs)
	if (locale === "fi") return fi_jobs_tab_search_criteria(inputs)
	if (locale === "da") return da_jobs_tab_search_criteria(inputs)
	if (locale === "sv") return sv_jobs_tab_search_criteria(inputs)
	return en_jobs_tab_search_criteria(inputs)
});